import React, { useEffect, useState } from "react";
import s from "./Groups.module.scss";
import clsx from "clsx";
import dayjs from "dayjs";
import ReusableTable from "../../../../../../global components/Table/Table";
import NoData from "../../../../../../global components/Table/NoData/NoData";
import SelectField from "../../../../../../global components/Forms/SelectField/SelectField";
import Paginate from "../../../../../../global components/Paginate/Pagination";
import ContactsGroup from "../../../../../../global components/Icons/ContactGroup/ContactsGroup";
import { useQuery } from "../../../../../../libs/common";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import useSWR from "swr";
import {
  parseClientError,
  swrFetcher,
} from "../../../../../../libs/api/Endpoints";
import { GroupContactsPaginatedResponse } from "../../../../../../libs/Utils/Types/User";
import Unauthorised from "../../../../../../global components/Unauthorised";

type Group = {
  name: string;
  id: string;
};
function Groups() {
  const [filter, setFilter] = useState<string>("");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageItems, setPageItems] = useState(10);
  const query = useQuery();
  const userId = query.get("userId");
  const token = UseAuthToken();
  const {
    data: groups,
    isLoading,
    error: groupError,
  } = useSWR<{ data: Group[] }, any, any>(
    token ? [`api/admin/users/${userId}/contact-groups`, token] : null,
    swrFetcher,

    {
      revalidateOnFocus: true, // Refetch when the window regains focus
      // Refetch every 10 seconds (10000 ms)
      shouldRetryOnError: false, // Disable retrying on errors
    },
  );
  const {
    data: groupContact,
    isLoading: loading,
    error,
  } = useSWR<GroupContactsPaginatedResponse, any, any>(
    token
      ? [
          `api/admin/users/${userId}/contact-groups/${filter}`,
          token,
          { page: currentPage, limit: pageItems },
        ]
      : null,
    swrFetcher,

    {
      //revalidateOnFocus: true, // Refetch when the window regains focus
      // Refetch every 10 seconds (10000 ms)
      shouldRetryOnError: false, // Disable retrying on errors
      //isPaused: () => groups && !filter,
    },
  );
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name: string) => (
        <span className={clsx(s.cell, s.name)}>{name}</span>
      ),
    },
    {
      title: "Email address",
      dataIndex: "email",
      key: "email",
      render: (email: string) => <span className={clsx(s.cell)}>{email}</span>,
    },
    {
      title: "Phone number",
      dataIndex: "phoneNo",
      key: "phoneNo",
      render: (phoneNo: string) => (
        <span className={clsx(s.cell)}>{phoneNo}</span>
      ),
    },

    {
      title: "Date created",
      dataIndex: "date",
      key: "date",
      render: (date: string) => (
        <span className={s.cell}>
          {" "}
          {dayjs.utc(date).local().format("MMM D, YYYY hh:mm A")}
        </span>
      ),
    },
  ];

  console.log(groupContact?.data);
  const transformedData =
    groupContact?.data.map((contact) => ({
      key: contact.id,
      name:
        (contact.firstName ? contact.firstName : "N/A") +
        " " +
        (contact.lastName ? contact.lastName : "N/A"),
      email: contact.email || "N/A",
      phoneNo: contact.phoneNo || "N/A",
      date: contact.createdAt,
    })) ?? [];

  // Handle error state

  const handlePageChange = (page: number, size: number) => {
    setCurrentPage(page);
    setPageItems(size);
  };
  function handleFilter(value: string) {
    setFilter(value);
  }
  useEffect(() => {
    if (groups && groups?.data.length > 0) {
      setFilter(groups.data[0].id);
    }
  }, [groups]);

  return groups && groups?.data.length <= 0 ? (
    <div>
      <h5>No groups yet</h5>
    </div>
  ) : groupError ? (
    <Unauthorised
      error={{
        message:
          parseClientError(groupError).message || "Groups failed to load",
        title: "Error!",
      }}
    />
  ) : (
    <div className={s.table}>
      <div className={s.searchParams}>
        <div className={s.input}>
          <SelectField
            bordered
            defaultValue={
              filter ||
              (groups &&
                groups?.data.length > 0 &&
                groups?.data[0] &&
                groups.data[0].id)
            }
            label={"Group:"}
            wrapperClassname={s.SelectWrapper}
            onChange={(value: any) => handleFilter(value)}
            className={s.selectInput}
            style={{ width: "100%", height: "100%" }}
            options={
              groups && groups?.data.length > 0
                ? groups?.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))
                : []
            }
          />
        </div>
        <div className={s.paginate}>
          <Paginate
            onChange={handlePageChange}
            total={groupContact?.pagination?.totalItems || 0}
            pageSize={pageItems}
          />
        </div>
      </div>
      <ReusableTable
        loading={isLoading || loading}
        noDataComponent={
          error ? (
            <Unauthorised
              error={{
                message:
                  parseClientError(error).message || "Contacts failed to load",
                title: "Error!",
              }}
            />
          ) : (
            <NoData
              Message="No contact found"
              subMessage=""
              icon={<ContactsGroup fill="#010516" height={80} width={80} />}
            />
          )
        }
        dataSource={transformedData || []}
        columns={columns}
        //rowSelection={rowSelection} // Include row selection prop
      />
    </div>
  );
}

export default Groups;
